import React, { useState, useEffect, useRef} from 'react';
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import RequestsReceived from '../Components/Shares/RequestsReceived.js';
import CreationRequestsGetter from '../Controller/getSQLCreationRequestsFunctions.js';
import {FormattedMessage} from 'react-intl';

const ReceivedInvitationsMenu = (props) => {

    const [requests_List, setRequestsList] = useState([]);
    const requestsListRef = useRef();
    requestsListRef.current = requests_List;

    useEffect(() => {
        props.reloadUserAndProfiles()
        retrieveOnGoingRequestsList();
    },  
    //eslint-disable-next-line
    []);

    const retrieveOnGoingRequestsList = async () => {

        let local_Requests_List = await CreationRequestsGetter.get_requests_received_list(props.userEmail);
    
        if((local_Requests_List !== null)&&(local_Requests_List !== undefined)&&(local_Requests_List.length !== 0)){ 
          setRequestsList(local_Requests_List); 
        }
    };

    const { classes } = props;

    /**Component generating two tabs*/
    return (
        <div className={classes.popup_background}>
            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="management-menu-popup">
                    <Row className="justify-content-md-end" style = {{ height: "5%", paddingBottom: "20px" }}>
                        <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                            <center>
                                <FormattedMessage id="invitation.title" defaultMessage="Invitations" />
                            </center>
                        </Col>
                    </Row>
                    <Row style={{overflowY:"auto", height: '90%'}}>
                        <RequestsReceived requests_List={requests_List} profilesInformation={props.profilesInformation} accountMailAddress={props.accountMailAddress} reloadUserAndProfiles={props.reloadUserAndProfiles}/>
                    </Row>
                    <Row>
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                                <FormattedMessage id="button.close" defaultMessage="Close" />                                           
                            </button>
                        </center>
                    </Row>
                </div>
            </div>
        </div>
    );
};
export default withStyles(Constants.styles)(ReceivedInvitationsMenu);